export const Icons = {
    style: "🔎",
    date: "🗓️",
    suitableFor: "🔍",
    difficulty: "🥾",
    duration: "⏱️",
    location: "📍",
    groupSize: "👥",
    clock: "⏰",
    woman: "🚺",
    man: "🚹",
    gender: "🚻"
};
